import { stripBreakpointPrefix } from '@yola/atomic-css-generator';
import matchesResponsiveToken from '../helpers/matches-responsive-token';

const hasResponsiveClass = ({ element, className, breakpoint }) => {
  const currentClass = element && element.getAttribute('class');
  if (!currentClass) return false;

  return currentClass.split(' ').some((cls) => {
    if (!cls) return false;
    if (breakpoint) return matchesResponsiveToken(cls, className, breakpoint);
    const stripped = stripBreakpointPrefix(cls);
    return stripped === className || stripped.startsWith(`${className}-`);
  });
};

export default hasResponsiveClass;
